export default function <T>(
  idToEntity: {[key: number]: T},
  id: number,
): T | null {
  if (!idToEntity[id]) {
    return null;
  }
  return idToEntity[id];
}
